export default __webpack_public_path__ + "static/media/withdrawal.d02556c3.svg";